import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd';
import { Button, Checkbox, Grid, Modal, Segment } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';

interface Props {
  toggleProps: any;
}

function ReportsModal({ toggleProps }: Props) {
  const {
    dashboardStore,
    commonStore: { hfcCustomerChanges },
  } = useStore();
  const [, setOpen] = useState<any>(true);
  const [checkedItems, setCheckedItems] = useState<any>([]);
  const [toggleObjValue, setToggleObjValue] = useState<any>([]);
  const [, setSubTaskElements] = useState<any[] | undefined>();

  useEffect(() => {
    const getCheckedItems: any = localStorage.getItem(
      dashboardStore.dashboard.tableName,
    );
    // if(getCheckedItems !== undefined && getCheckedItems !== null) {
    dashboardStore.setHeaderTable(getCheckedItems);
    const ArrayFormat = getCheckedItems.split(',');
    const actualArr = ArrayFormat;
    const filteredArr = actualArr.filter(
      (item: any, index: any, self: any) => self.indexOf(item) === index,
    );

    setToggleObjValue(filteredArr);
    setCheckedItems(actualArr);
    // }
    // localStorage.removeItem(dashboardStore.dashboard.tableName)
  }, [dashboardStore]);
  const test = (e: any) => {
    const currTrgt: any = e.currentTarget.attributes['toggleName'].value;
    if (e.currentTarget.children[0].checked === false) {
      setCheckedItems([...checkedItems, currTrgt]);
    } else {
      setCheckedItems(
        checkedItems.filter(
          (item: any) => item.toLowerCase() !== currTrgt.toLowerCase(),
        ),
      );
    }
  };

  const setOpenModal = () => {
    localStorage.setItem(dashboardStore.dashboard.tableName, checkedItems);
    dashboardStore.reportsConfigurationOpen(false);
  };

  const onDragEnd = (result: DropResult) => {
    const { source, destination } = result;
    if (!destination) return;
    const items = Array.from(dashboardStore.dashboard.headerTable);
    const [newOrder] = items.splice(source.index, 1);
    items.splice(destination.index, 0, newOrder);
    setSubTaskElements(items);
    const dragandDrop = destination.index.toString();
    localStorage.setItem('drag', dragandDrop);
    const getCheckedItemss: any = localStorage.getItem('drag');
    dashboardStore.setDrag(getCheckedItemss);
  };

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={dashboardStore.dashboard.reportsConfiguration}
    >
      <Modal.Header>{dashboardStore.dashboard.tableName}</Modal.Header>
      <Segment style={{ height: '70vh' }}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div
                className="templatepreset workflow-config-elements"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                <Grid columns={3}>
                  {toggleObjValue?.length !== 0 &&
                    toggleProps?.map((dat: any, index: number) => {
                      dashboardStore?.setFinalValue(
                        toggleObjValue?.includes(dat),
                      );
                      return (
                        // <Draggable key={dat} draggableId={dat} index={index}>
                        //   {(provided) => (
                        //     <div
                        //       ref={provided.innerRef}
                        //       {...provided.draggableProps}
                        //       {...provided.dragHandleProps}
                        //     >
                        <>
                          {dat !== 'id' && dat !== 'title' ? (
                            <Grid.Column
                              style={{
                                color: 'black',
                              }}
                            >
                              <Grid columns={2}>
                                <Grid.Row>
                                  <Grid.Column width={10}>
                                    {hfcCustomerChanges &&
                                    dat === 'barcode_Package'
                                      ? 'Print'
                                      : dat?.charAt(0)?.toUpperCase() +
                                        dat?.slice(1)?.split('_').join(' ')}
                                  </Grid.Column>
                                  <Grid.Column width={6}>
                                    <Checkbox
                                      key={index}
                                      toggleName={dat}
                                      onClick={(e) => {
                                        test(e);
                                      }}
                                      toggle
                                      defaultChecked={
                                        toggleObjValue.includes(dat) ||
                                        toggleObjValue.includes(
                                          dat.toLowerCase(),
                                        )
                                          ? true
                                          : false
                                      }
                                      style={{
                                        marginTop: '5px',
                                      }}
                                    />
                                  </Grid.Column>
                                </Grid.Row>
                              </Grid>
                            </Grid.Column>
                          ) : null}
                        </>
                        //    </div>
                        //   )}
                        // </Draggable>
                      );
                    })}
                </Grid>
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Segment>
      <Modal.Actions>
        <Button
          color="black"
          onClick={() => dashboardStore.reportsConfigurationOpen(false)}
        >
          Cancel
        </Button>
        <Button
          content="Submit"
          labelPosition="right"
          icon="checkmark"
          onClick={() => setOpenModal()}
          positive
        />
      </Modal.Actions>
    </Modal>
  );
}
export default observer(ReportsModal);
